import * as React from "react";
import { Client } from "../../interfaces/ClientInterface";
import { ServiceProvider } from "../../interfaces/ServiceProvidersInterface";
import ClientCreateEditForm from "./ClientCreateEditForm";

interface Props {
  clientId?: number;
  client?: Client;
  mode: string;
  onCancel: () => void;
  showLastCreated?: () => void;
  stayOnCurrentPage: boolean;
  isCorporateClient?: boolean;
  setEditMode?: React.Dispatch<React.SetStateAction<boolean>>;
  afterSave?: () => void;
  saveButtonText?: string;
  isForClientRegistration?: boolean;
  isForLeadClientBilling?: boolean;
  onSpChange?: (sp: ServiceProvider) => void;
  wrapperStyle?: Record<string, string>;
  clientDefaultName?: string;
  showFooter?: boolean;
}

const ClientCreateEdit = ({
  wrapperStyle = {},
  clientDefaultName = "",
  showFooter = true,
  ...rest
}: Props): React.JSX.Element => (
  <ClientCreateEditForm
    wrapperStyle={wrapperStyle}
    clientDefaultName={clientDefaultName}
    showFooter={showFooter}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

export default ClientCreateEdit;
